import * as React from "react"
import { AppTableSeeker } from "@components"

import {PRICING_ROUTES} from "@constants";
import {useShareUrl} from "@hooks";
import { endDate } from "@signals"
import { prevEndDate } from "@signals/filters"
import { usePricingDiscountRoleConfig } from "Pages/Pricing/PriceDiscount/@hooks";
import {imageSkuColumn, priceColumn, skuColumn, skuRetailerColumn, minRetailerPriceColumn, percentageColumn, competitorColumn} from "./columns"
import PriceDiscountTopMarketDispersionsTableActions from "./Actions";
import PricingDiscountTableTitleLink from "../../TableTitleLink";


export default function PriceDiscountTopMarketDispersionsTable({ data, selectedCountry, countries, handleSelectedCountry, noDataText}) {
	
	const { isStandardUser, isRetailerUser } = usePricingDiscountRoleConfig()
	const { buildShareParams } = useShareUrl()

	return <AppTableSeeker
		title={
			<PricingDiscountTableTitleLink 
			title="Market Comparison" 
			tooltip="Go to Market Analyzer"
			url={`${PRICING_ROUTES.MARKET_ANALYZER_PATH}?sp=${buildShareParams(
				{country: selectedCountry ? selectedCountry.toLowerCase() : null, currentSingleDate: endDate.value, prevSingleDate: prevEndDate.value}
			)}&launch=true`} 
		/>}
		data={data}
		columns={[
			imageSkuColumn(),
			...isStandardUser ? [skuColumn()] : [],
			...isRetailerUser ? [skuRetailerColumn()] : [],
			...isRetailerUser ? [priceColumn('myListPrice', 'My Min List Price', true)] : [],
			priceColumn(isStandardUser ? 'myPrice' : 'myActualPrice', isStandardUser ? 'RRSP' : 'My Min Current Price', isRetailerUser ? true : false),
			minRetailerPriceColumn('minPrice', 'Min. Price'),
			percentageColumn('minDiff', 'Price Dispersion'),
			competitorColumn()
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPage: 5,
			rowsPerPageOptions: [5, 10],
			customToolbar: () => {
				return <PriceDiscountTopMarketDispersionsTableActions
					selectedCountry={selectedCountry}
					countries={countries}
					onClick={handleSelectedCountry}
				/>
			}
		}}
		textLabels= {{
			body: {
				noMatch: noDataText,
			}
		}}
	/>
}